import { useCallback, useState } from 'react'
import { message } from 'antd'
import { onCSVExport } from 'utils/verticals'
import { useCurrency } from 'contexts'
import { getUrlPageValues } from 'containers/VerticalPage/common/utils'
import { _source } from 'utils/csvConfig'

interface UseSTRExportParams {
  sorting: { id: string; desc: boolean }[]
  total: number
  verticalIndices?: string
}

export const useSTRExport = ({ sorting, total, verticalIndices }: UseSTRExportParams) => {
  const [exportSuccessMsg, setExportSuccessMsg] = useState<string | null>(null)
  const { currentCurrency, exchangeRates, isLoadingExchangeRates } = useCurrency()

  const handleExport = useCallback(
    (exportSelectedIds?: string[]) => {
      if (!verticalIndices) return

      const currencyContext = {
        currencyConversion: currentCurrency !== 'USD',
        currentCurrency,
        exchangeRates: exchangeRates?.[`${currentCurrency}_all_yearly`] || null,
      }
      const count = exportSelectedIds?.length || total

      onCSVExport(
        verticalIndices,
        _source,
        getUrlPageValues()[0],
        'ShortTermRentals',
        '',
        () => {},
        exportSelectedIds,
        sorting,
        currencyContext,
      )
        .then(() => setExportSuccessMsg(`${count} cases successfully exported`))
        .catch(() => message.error('File export failed, please try again later'))
    },
    [sorting, total, currentCurrency, exchangeRates, verticalIndices],
  )

  const clearExportMsg = useCallback(() => setExportSuccessMsg(null), [])

  return { handleExport, exportSuccessMsg, clearExportMsg, isLoadingExchangeRates }
}
